<template>
	<div class="news">
    	<HeaderTop :activeIndex="activeIndex"></HeaderTop>
		<div class="news-bannerbox">
			<img src="../../assets/bannerNews_2.png" class="bannerbox-banner">
		</div>
		<div class="news-notice">
			<div class="notice-nav clearfix">
				<ul class="nav-option">
					<li :class="index==0?'option active':'option'" ref="option" @click="changeActive(item,index)" v-for="item,index in classifyList" :key="index"><a>{{item.name}}</a></li>
				</ul>
				<div class="nav-right">
					<div class="nav-content" v-for="item,index in noticeList" :key="index">
						<div class="content clearfix">
							<a @click="goNewsDetail(item.id)" class="content-text">{{item.title}}</a>
							<p class="content-date">{{item.publishTime|dateFormat}}</p>
						</div>
					</div>
				</div>
			</div>
			<el-pagination
				class="pagination"
				background
				layout="prev, pager, next"
				:total="paging.total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</div>
        <Footer></Footer>
	</div>
</template>

<script>
import HeaderTop from "./HeaderTop.vue";
import Footer from "./Footer.vue";

export default {
    name: 'News',
    components: {
		Footer,
		HeaderTop
    },
	data() {
		return {
      paging:{
        page: 1,
        pageCount: 1,
        pageSize: 10,
        total: 1,
      },
      params: {
        classifyId: '',
        page: 1,
        pageSize: 10
      },
			activeIndex: 'newyear-news',
			// 公告分类列表
			classifyList:[],
      // 列表
      noticeList:[]
		};
	},
  computed: {

  },
  created() {
    this.getClassify()
  },
	mounted() {
	},
	methods: {
    // 公告分类列表
    async getClassify() {
      await this.axios.get("/portal/classify").then((res)=>{
        this.classifyList = res.data
        this.params.classifyId = res.data[0].id
      })
      this.getNotice()
      if(this.$route.query.item) {
        this.changeActive(this.$route.query.item,this.$route.query.index)
      } else {
        return
      }
    },
    // 左侧导航切换
		changeActive(item,index) {
			this.$refs.option.forEach(item=>{
				item.className='option'
			})
			this.$refs.option[index].className='option active'
      this.params = {
        classifyId: item.id,
        page: 1,
        pageSize: 10
      }
      this.getNotice()
		},
    // 列表数据
    async getNotice() {
      let params = this.params
      await this.axios.get('/portal/notice',{params}).then((res)=>{
        this.noticeList = res.data
        this.paging = JSON.parse(res.headers.paging)
      })
    },
    // 页数切换
		handleCurrentChange(val) {
      this.params.page = val
      this.getNotice()
		},
    // 新闻详情页
		goNewsDetail(id) {
			this.$router.push({name: "newyear-detail",query: {id}});
		}
	},
}
</script>

<style lang="scss" scoped>
::v-deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
	background: #930B00;
}
::v-deep(.header-top .nav){
  background-color: #930B00;
  position: initial;
}
.news {
	.news-bannerbox {
		width: 1200px;
		margin: 0 auto;
		height: 340px;
		.bannerbox-banner {
			display: block;
			width: 1200px;
			height: 340px;
		}
	}
	.news-notice {
		padding: 30px 0 20px 0;
		background-color: #F8F8F8;
		.notice-nav {
			width: 1200px;
			margin: 0 auto;
			display: flex;
			.nav-option {
				margin: 0;
				padding-left: 0;
				.option {
					background-color: #fff;
					display: block;
					width: 200px;
					line-height: 60px;
					text-align: center;
					font-size: 16px;
					color: #666666;
					cursor: pointer;
				}
				.active {
					background-color: #FFA400;
					color: #FFFFFF;
				}
			}
			.nav-content {
				background-color: #FFFFFF;
				padding: 0 30px;
				width: 1000px;
				box-sizing: border-box;
        cursor: pointer;
				.content {
					.content-text {
						float: left;
						color: #333333;
						font-size: 14px;
						line-height: 40px;
						max-width: 850px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.content-text:hover {
						color: #930B00;
					}
					.content-date {
						float: right;
						color: #999999;
						font-size: 14px;
						line-height: 40px;
					}
				}
			}
			.nav-page {
				float: left;
				width: 100%;
			}
		}
		.pagination {
			display: flex;
			justify-content: center;
		}
	}
}
</style>